module.exports = __webpack_public_path__ + "static/media/widgetStreetMap.635098c7.svg";